import React from 'react'
import { Box, Button, TextField, Typography } from '@mui/material'

import type { DoneUploadItem } from '../PatientFilesUpload'
import type { RenameState } from './useRenameFile'

type Props = {
  item: DoneUploadItem
  activeRename: RenameState | null
  renameInputRef: React.RefObject<HTMLInputElement | null>
  onRenameFilenameChange: (newFilename: string) => void
  onCancelRename: () => void
  onSaveRename: (item: DoneUploadItem) => void
}

const RenameEditor = ({
  item,
  activeRename,
  renameInputRef,
  onRenameFilenameChange,
  onCancelRename,
  onSaveRename,
}: Props) => (
  <Box>
    <Box display="flex" alignItems="center" gap={0.5}>
      <TextField
        size="small"
        autoFocus
        inputRef={renameInputRef}
        value={activeRename?.newFilename ?? item.file.filename}
        disabled={Boolean(activeRename?.isLoading)}
        error={Boolean(activeRename?.error)}
        sx={{ width: 260, maxWidth: '100%', marginTop: 0 }}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => onRenameFilenameChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            onSaveRename(item)
          }
          if (e.key === 'Escape') {
            onCancelRename()
          }
        }}
      />
      <Button
        size="small"
        variant="outlined"
        disabled={Boolean(activeRename?.isLoading)}
        onClick={(e) => {
          e.stopPropagation()
          onCancelRename()
        }}
      >
        Cancel
      </Button>
      <Button
        size="small"
        variant="contained"
        disabled={Boolean(activeRename?.isLoading)}
        onClick={(e) => {
          e.stopPropagation()
          onSaveRename(item)
        }}
      >
        Save
      </Button>
    </Box>
    {activeRename?.error && (
      <Typography variant="caption" color="error" ml={1}>
        {activeRename.error}
      </Typography>
    )}
  </Box>
)

export default RenameEditor
